import React from 'react';
import CurrencyFormat from 'react-currency-format';
import { Form, Row, Col, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Field } from 'formik';

function FormCurrencyInputFieldInner(props) {
  const { label, placeholder, form, field, disabled, required = false } = props;

  const error = form.errors[field.name];
  const touched = form.touched[field.name];
  const value = form.values[field.name] ?? '0';

  return (
    <Row className="mb-3">
      <Col>
        <Form.Group
          controlId={field.name}
          className={(form.submitCount > 0 || touched) && error ? 'field-error' : ''}
        >
          <Form.Label className={required ? 'label-required' : ''}>{label}</Form.Label>
          <InputGroup>
            <InputGroup.Text>£</InputGroup.Text>
            <CurrencyFormat
              thousandSeparator
              allowNegative={false}
              customInput={Form.Control}
              placeholder={placeholder}
              value={value}
              disabled={form.isSubmitting || disabled}
              onBlur={() => form.setFieldTouched(field.name, true)}
              onChange={({ target }) => {
                const numeric = target.value.replace(/[^0-9.]/g, '');
                form.setFieldValue(field.name, numeric === '' ? '0' : numeric);
              }}
              isInvalid={!!((form.submitCount > 0 || touched) && error)}
            />
          </InputGroup>
          {(form.submitCount > 0 || touched) && error && (
            <Form.Control.Feedback type="invalid" className="d-block fs-5">
              {error}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      </Col>
    </Row>
  );
}

function FormCurrencyInputField(props) {
  return <Field {...props} component={FormCurrencyInputFieldInner} />;
}

FormCurrencyInputField.defaultProps = {
  placeholder: '',
  disabled: false,
};

FormCurrencyInputField.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FormCurrencyInputField;
